import { render } from "./CustomConfirm.vue?vue&type=template&id=158252ca&scoped=true"
import script from "./CustomConfirm.vue?vue&type=script&lang=js"
export * from "./CustomConfirm.vue?vue&type=script&lang=js"

import "./CustomConfirm.vue?vue&type=style&index=0&id=158252ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158252ca"]])

export default __exports__